/** 全局变更流：后端事务提交后推送事件，前端按资源失效缓存。断线自动重连。 */
import type { QueryClient } from "@tanstack/react-query";
import { invalidation } from "./hooks";

export type ChangeEvent = {
  type: string;
  resource: string;
  id: string | null;
  data: Record<string, unknown>;
};

export function connectChanges(qc: QueryClient, onEvent?: (event: ChangeEvent) => void): () => void {
  let source: EventSource | null = null;
  let closed = false;
  let retry = 1000;

  const open = () => {
    if (closed) return;
    source = new EventSource("/api/v1/events");
    source.addEventListener("change", (message) => {
      retry = 1000;
      const event = JSON.parse((message as MessageEvent<string>).data) as ChangeEvent;
      for (const key of invalidation[event.resource] ?? []) {
        void qc.invalidateQueries({ queryKey: key });
      }
      onEvent?.(event);
    });
    source.onerror = () => {
      source?.close();
      if (closed) return;
      retry = Math.min(retry * 2, 15000);
      setTimeout(open, retry);
    };
  };

  open();
  return () => {
    closed = true;
    source?.close();
  };
}
